import {useEffect} from "react";
import {useEffectState} from "./useEffectState";

export function useDomcumentOnClick(callback: (event: MouseEvent) => void) {
    const state = useEffectState({
        tradingView_status: false
    });

    useEffect(() => {
        document.addEventListener("click", domOnClick);
        return () => {
            document.removeEventListener("click", domOnClick);
        }
    }, []);

    useEffect(() => {
        let tradeview = document.getElementById("trade-view");
        let iframe: HTMLIFrameElement | null = (tradeview && tradeview.children[0]) as HTMLIFrameElement;
        if (iframe && iframe.contentWindow) {
            iframe.contentWindow.document.addEventListener("click", domOnClick)
        }

        return () => {
            if (iframe && iframe.contentWindow) {
                iframe.contentWindow.document.removeEventListener("click", domOnClick);
            }
        }
    }, [state.tradingView_status]);

    function domOnClick(event: MouseEvent) {
        callback(event)
    }
}
